import { Dial, DIALS, OVERLAY_INSET, VolumeChannel } from '~/modules/elements/volume-dials';

const VolumeDial = ({ dial, value, active }: { dial: Dial; value: number; active: boolean }) => {
  const radius = (dial.size - dial.stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const isLarge = dial.size > 150;

  return (
    <div
      className="absolute flex items-center justify-center"
      style={{
        right: dial.right,
        bottom: dial.bottom,
        width: dial.size,
        height: dial.size,
        filter: active ? `brightness(1.2) drop-shadow(0 0 16px ${dial.color})` : 'brightness(0.8)',
      }}>
      <svg width={dial.size} height={dial.size} className="-rotate-90">
        <circle cx={dial.size / 2} cy={dial.size / 2} r={radius} stroke="#222" strokeWidth={dial.stroke} fill="none" />
        <circle
          cx={dial.size / 2}
          cy={dial.size / 2}
          r={radius}
          stroke={dial.color}
          strokeWidth={dial.stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - value / 100)}
          className="transition-[stroke-dashoffset] duration-200"
        />
      </svg>
      <span
        className="typography absolute top-1/2 left-0 -translate-x-[110%] -translate-y-1/2 font-bold whitespace-nowrap text-white drop-shadow-[0_0_8px_black]"
        style={{ fontSize: isLarge ? 28 : 18 }}>
        {dial.label}
      </span>
      <span
        className="typography absolute font-bold text-white drop-shadow-[0_0_8px_black]"
        style={{ fontSize: isLarge ? 48 : 28 }}>
        {Math.round(value)}%
      </span>
    </div>
  );
};

interface Props {
  volumes: Record<VolumeChannel, number>;
  /** The channel just adjusted, highlighted so it is obvious which number moved. */
  active: VolumeChannel;
  visible: boolean;
}

export default function VolumeOverlay({ volumes, active, visible }: Props) {
  return (
    <div
      data-test="volume-overlay"
      data-active={active}
      data-visible={visible}
      style={{ right: OVERLAY_INSET, bottom: OVERLAY_INSET }}
      className={`pointer-events-none fixed z-1000 h-[13.75rem] w-[16.25rem] transition-opacity duration-200 ${
        visible ? 'opacity-100' : 'opacity-0'
      }`}>
      {DIALS.map((dial) => (
        <VolumeDial key={dial.channel} dial={dial} value={volumes[dial.channel]} active={active === dial.channel} />
      ))}
    </div>
  );
}
